//
// This is file for the temporary dummy agenda dashboard, which exists just for us developers
// to check the current normalizded event data. We should not build on this.
// So it's not build to our usual standards (is very far off even), so ignore any ugly, hacky and
// unused code.
//

// App specific
// import moment from 'moment-timezone';
import i18n from '@/i18n';
import agendaDebugApi from '../api/agenda-debug-api';
import router from '../../../router';

// initial state
const state = {
  all: [],
  current: null,
  filters: [],
  query: '',
  startDate: '',
  endDate: '',
};

// getters
const getters = {
  agendaDebugAll: (state) => state.all,
  agendaDebugCurrent: (state) => state.current,
  agendaDebugFilters: (state) => state.filters,
  agendaDebugQuery: (state) => state.query,
  agendaDebugStartDate: (state) => state.startDate,
  agendaDebugEndDate: (state) => state.endDate,
};

// actions
const actions = {

  setAgendaDebugQuery({ commit }, payload) {
    commit('setAgendaDebugQuery', payload);
  },

  setAgendaDebugFilters({ commit }, args) {
    commit('setAgendaDebugFilters', args);
  },

  setAgendaDebugStartDate({ commit }, payload) {
    commit('setAgendaDebugStartDate', payload);
  },

  setAgendaDebugEndDate({ commit }, payload) {
    commit('setAgendaDebugEndDate', payload);
  },

  agendaDebugSetAllSearchParameters({ commit }, searchParameters) {
    commit('setAgendaDebugQuery', searchParameters.query);
    commit('setAgendaDebugFilters', searchParameters.filters);
  },

  async getAllAgendasDebug({ commit, getters }) {
    const query = getters.agendaDebugQuery;

    const filters = getters.agendaDebugFilters;

    const startDate = getters.agendaDebugStartDate;

    const endDate = getters.agendaDebugEndDate;

    // Reset all errors
    // commit('clearMessages');

    // Set previous results to zero to set the agenda page empty
    commit('setAgendasDebug', []);

    // Validate a query has been set.
    if (!query) {
      commit('setMessage', {
        message: i18n.t('generic.specifySubject'),
        type: 'info',
      }, { root: true });

      return;
    }

    if (query) {
      let origin;
      if (router.currentRoute.query.origin) {
        ({ origin } = router.currentRoute.query.origin);
      }
      const response = await agendaDebugApi.getAll(query, filters, startDate, endDate, origin);
      if (response.data.countTotal === 0 && (router.currentRoute.name !== 'nlDashboard')) {
        // TODO: It occurs that the error intercepting mechanism in interceptors.js is not working properly
        // See POLMONNL-1972 for details.
        this.dispatch('setMessage', {
          message: i18n.t('agenda.noMeetingsFound'),
          type: 'info',
        }, { root: true });
      } else {
        const agendas = response.data.events;
        commit('setAgendasDebug', agendas);
      }
    }
  },

  async getAgendaDebugById({ commit }, args) {
    const agenda = await agendaDebugApi.getById(args.id, args.query, args.origin);

    // // Scraper agendas without startTime have startTime set to 00:01 in the collector,
    // // so they can be found with the elasticsearch query.
    // // We set startTime to endTime for consistency with the api agendas
    // const agendaData = agenda.data;
    // const fixedStartTime = new Date(agendaData.startTime);
    // if (fixedStartTime.getMinutes() === 1) {
    //   fixedStartTime.setMinutes(0);
    //   const startTimeAMS = moment.tz(fixedStartTime, 'Europe/Amsterdam');
    //   const startOfDayAMS = moment(startTimeAMS).startOf('day');
    //   if ((startTimeAMS.isSame(startOfDayAMS))) {
    //     agenda.data.result.startTime = agenda.data.result.endTime;
    //   }
    // }

    commit('setAgendaDebugCurrent', agenda.data);
    return agenda;
  },

};

// mutations
const mutations = {
  setAgendasDebug(state, agendas) {
    state.all = agendas;
  },
  setAgendaDebugCurrent(state, agenda) {
    state.current = agenda;
  },
  setAgendaDebugFilters(state, args) {
    state.filters = args;
  },
  setAgendaDebugQuery(state, query) {
    state.query = query;
  },
  setAgendaDebugStartDate(state, startDate) {
    state.startDate = startDate;
  },
  setAgendaDebugEndDate(state, endDate) {
    state.endDate = endDate;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
